<div class="container row">
  <ng-container *appHasPermission="'user_passwordrestore'">
    <app-config-line
      [title]="'Actualizar contraseña de usuario'"
      [description]="'Cambia la contraseña de tu cuenta para mantener la seguridad. Asegúrate de elegir una combinación segura de letras, números y símbolos.'"
      [titleLevel]="7"
      [withHr]="false"
    >
    </app-config-line>
    <app-config-line
      [title]="('CONFIGURATION.SECTIONS.USER.PASSWORD_CHANGE.CURRENT_PASSWORD' | translate)"
      [description]="'Ingrese la clave que usa actualmente para acceder a su cuenta'"
    >
      <input 
        type="password" 
        id="oldPass" 
        [(ngModel)]="userInfoForm.oldPass" 
        name="oldPass" 
        pInputText 
        class="form-control form-control-sm col-8" 
        placeholder="Contraseña actual" 
        tooltipPosition="right"
        style="width: 240px"
        required 
      />
    </app-config-line>

    <app-config-line
      [title]="('CONFIGURATION.SECTIONS.USER.PASSWORD_CHANGE.NEW_PASSWORD' | translate)"
      [description]="'Cree una nueva contraseña segura con al menos 8 caracteres'"
    >
      <input 
        type="password" 
        id="newPass" 
        [(ngModel)]="userInfoForm.newPass" 
        name="newPass" 
        pInputText 
        class="form-control form-control-sm col-8" 
        placeholder="Nueva contraseña" 
        tooltipPosition="right"
        style="width: 240px"
        required 
      />
    </app-config-line>

    <app-config-line
      [title]="('CONFIGURATION.SECTIONS.USER.PASSWORD_CHANGE.CONFIRM_PASSWORD' | translate)"
      [description]="'Repita la nueva contraseña para confirmar que coincide'"
    >
      <input 
        type="password" 
        id="newPassRepeat" 
        [(ngModel)]="userInfoForm.newPassRepeat" 
        name="newPassRepeat" 
        pInputText 
        class="form-control form-control-sm col-8" 
        placeholder="Confirmar contraseña" 
        tooltipPosition="right"
        style="width: 240px"
        required 
      />
    </app-config-line>

    <!-- Botón de Enviar -->
    <div class="d-flex justify-content-between">
      <div class="w-50 mx-auto">
        <button 
          _ngcontent-cic-c118="" 
          class="btn-gl-save btn-dark-hover btn-sm w-100"
          (click)="confirm()"
        > 
          {{'GENERAL.SAVE_CHANGES' | translate}}
        </button>
      </div>
    </div>
  </ng-container>
</div>